import currentHarvestData from './harvestData.preval'
import { getMetafield } from './getMetafield'

/**
 * Find a harvest by its handle, with optional partial matching
 * @param {string} harvestHandle - The handle to search for
 * @param {boolean} allowPartialMatch - Whether to allow partial matches of the handle
 * @returns {Object|null} The found harvest or null
 */
export function findHarvestByHandle(harvestHandle, allowPartialMatch = false) {
  // Try exact match first
  const exactMatch = currentHarvestData.find(
    h => h.handle === harvestHandle && h.type === 'harvest'
  );

  if (exactMatch || !allowPartialMatch) {
    return exactMatch || null;
  }

  // Try partial match if allowed and exact match failed
  return currentHarvestData.find(
    h => h.handle && h.handle.includes(harvestHandle) && h.type === 'harvest'
  ) || null;
}

export function getHarvestHandle(variant, product) {
  const harvestHandle = getMetafield({
    product,
    selectedVariant: variant,
    key: 'harvest_handle',
  })
  if (harvestHandle) return harvestHandle?.value
  else return product?.handle || product?.productHandle
}

export async function getHarvests({ product, variants, returnHarvestHandle }) {
  if (!variants) variants = product.variants
  const harvestsInfo = await variants.reduce(async (carry, variant) => {
    let promises = await carry

    const getHarvestInfo = async (item) => {
      if (
        item.metafields.some((metafield) => metafield.key === 'harvest_handle')
      ) {
        const harvestHandle = item.metafields.find(
          (metafield) => metafield.key === 'harvest_handle',
        ).value
        if (returnHarvestHandle) {
          promises.push(harvestHandle)
          return promises
        }

        let harvestContent = currentHarvestData.find(
          (h) => h.handle === harvestHandle && h.type === 'harvest',
        )
        var handleExists = promises.some(
          (p) => p.handle === harvestContent.handle,
        )
        if (harvestContent && !handleExists && harvestContent.handle !== '') {
          promises.push({
            ...harvestContent.fields,
            handle: harvestHandle,
            variantTitle: variant.content?.title,
          })
          return promises
        }
      }
    }

    // check if variant has metafield
    const variantHasMetafield = await getHarvestInfo(variant)
    if (variantHasMetafield) return variantHasMetafield

    // check if product has metafield
    const productHasMetafield = await getHarvestInfo(product)
    if (productHasMetafield) return productHasMetafield

    return promises
  }, Promise.resolve([]))

  return harvestsInfo
}
